import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function AllergenRecipeDeleteModal(props) {
  const { trigger, allergen, recipeName, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ id: allergen.id });

  const t = useTranslation();
  function deleteAllergenRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: allergenRecipeDeleteModalMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
          refetchData();
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    setLoading(true);
    deleteAllergenRecipe()
      .then((a) => {
        toast.success(t("message.deleted_allergen"));
        setModalOpen(false);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };

  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeIngredient")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: allergen.id });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.allergen_remove_recipe", {
            allergenName: allergen.allergen.name,
            recipeName: recipeName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            disabled={loading}
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const allergenRecipeDeleteModalMutation = graphql`
  mutation AllergenRecipeDeleteModalMutation($id: ID!) {
    recipeDeleteAllergen(input: { id: $id }) {
      deleted
    }
  }
`;
